import { getDataIdsFromContract } from '../shared/utils/dataId';

export const ENTITY_FORM_DATA_IDS = getDataIdsFromContract({
  base: 'entity-form',
  container: 'container',
  loadingShimmer: '',
  retryApiAlert: 'retry',
  form: '',
  errorBanner: 'error',
  testConnectionCTA: 'testConnection',
  submitCTA: 'submit',
  setupGuideDocs: '',
  testConnectionInProgress: 'testConnectionInProgress'
});
